export const build = {"tag":"v1.0.5","hash":"0e69410e","time":"261014.0907"}